module.exports = __webpack_public_path__ + "img/new_act.4b528aab.png";